/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { useNotifications } from '../../context/NotificationsContext';

export default function NotificationsBadge({ onClick }) {
  const { unreadCount } = useNotifications() || { unreadCount: 0 };
  const display = unreadCount > 99 ? '99+' : String(unreadCount || '0');
  return (
    <button
      type="button"
      aria-label="Notifications"
      onClick={onClick}
      className="relative inline-flex items-center justify-center w-9 h-9 rounded-full hover:bg-primary/20 focus:outline-none"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M12 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 006 14h12a1 1 0 00.707-1.707L18 11.586V8a6 6 0 00-6-6z" />
        <path d="M8 16a4 4 0 008 0H8z" />
      </svg>
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[1.25rem] h-5 px-1 rounded-full bg-red-600 text-white text-xs flex items-center justify-center">
          {display}
        </span>
      )}
    </button>
  );
}
